import {
  CUSTOMER_SEGMENT_B2C,
  CUSTOMER_SEGMENT_B2B,
  customerSegmentType,
  customerSegmentAgeRange,
  CUSTOMER_SEGMENT_TYPE_OPTIONS,
} from '../factories/customerSegment';

export {
  CUSTOMER_SEGMENT_B2C,
  CUSTOMER_SEGMENT_B2B,
  customerSegmentType,
  CUSTOMER_SEGMENT_TYPE_OPTIONS,
  customerSegmentAgeRange,
};
